import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axiosConfig/instance';

export const loginAsync = createAsyncThunk('auth/loginAsync', async ({ email, password }, { rejectWithValue }) => {
  const loginobj={
    "email": email,
    "password": password
  }
  console.log(password)
  console.log(email)
  try {
    const response = await axiosInstance.post('/v1/users/auth/login', loginobj);
    console.log(response)
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const fetchCurrentUser = createAsyncThunk('auth/fetchCurrentUser', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/v1/users/auth/profile');
    return response.data?.data || response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || { message: 'Failed to load profile' });
  }
});

const derivePermissionsFromProfile = (profile) => {
  if (!profile) return [];
  
  // Bask returns permissions nested under roles array
  if (Array.isArray(profile.roles)) {
    const allPermissions = profile.roles.flatMap(role => {
      if (role && Array.isArray(role.permissions)) {
        return role.permissions;
      }
      return [];
    });
    
    // Remove duplicates
    return [...new Set(allPermissions)];
  }
  
  // Fallback patterns
  if (Array.isArray(profile.permissions) && profile.permissions.every(p => typeof p === 'string')) {
    return profile.permissions;
  }
  if (Array.isArray(profile.permission_names)) return profile.permission_names;
  if (Array.isArray(profile.abilities)) return profile.abilities;
  
  return [];
};

const initialState = {
  user: null,
  token: localStorage.getItem('token') || null,
  error: null,
  status: 'idle',
  permissions: JSON.parse(localStorage.getItem('permissions') || '[]'),
};


const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem('token');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.loading = 'pending';
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload.data || null;
        state.token = action.payload.data.token;
        localStorage.setItem('token', action.payload.data.token);
        localStorage.setItem('refreshtoken', action.payload.data.refresh_token);
        
        // Extract permissions from login response
        const derived = derivePermissionsFromProfile(action.payload.data);
        state.permissions = derived;
        try {
          localStorage.setItem('permissions', JSON.stringify(derived));
        } catch(_) {}
        
        state.error = null;
      })
      .addCase(loginAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload ? action.payload.message : 'Login failed';
      })
      .addCase(fetchCurrentUser.pending, (state) => {
        state.status = 'loading-user';
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.status = 'user-loaded';
        state.user = action.payload || null;
        const derived = derivePermissionsFromProfile(state.user);
        state.permissions = derived;
        try {
          localStorage.setItem('permissions', JSON.stringify(derived));
        } catch(_) {}
      })
      .addCase(fetchCurrentUser.rejected, (state, action) => {
        state.status = 'user-failed';
        state.error = action.payload ? action.payload.message : 'Failed to load user';
        state.permissions = [];
        try {
          localStorage.setItem('permissions', JSON.stringify([]));
        } catch(_) {}
      });
  },
});



export const { logout } = authSlice.actions;
export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectError = (state) => state.auth.error;
export const selectPermissions = (state) => state.auth.permissions;
export default authSlice.reducer;